import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errorMessage } from "@/lib/api";
import { Field } from "@/components/common";

export function DepositDialog({ open, onOpenChange, roId, suggested, onDone }) {
  const [form, setForm] = useState({ amount: suggested || "", method: "carte", note: "" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/repair-orders/${roId}/deposits`, { ...form, amount: Number(form.amount) });
      toast.success("Acompte enregistré — il sera déduit automatiquement de la facture");
      onOpenChange(false); onDone();
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="deposit-dialog">
        <DialogHeader><DialogTitle>Encaisser un acompte</DialogTitle></DialogHeader>
        <div className="grid gap-3">
          <Field label="Montant TVAC (€)"><Input type="number" step="0.01" value={form.amount} onChange={(e) => setForm((f) => ({ ...f, amount: e.target.value }))} data-testid="deposit-amount" /></Field>
          <Field label="Mode"><Select value={form.method} onValueChange={(v) => setForm((f) => ({ ...f, method: v }))}><SelectTrigger data-testid="deposit-method"><SelectValue /></SelectTrigger><SelectContent>{["carte", "espèces", "virement", "Payconiq"].map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent></Select></Field>
          <Field label="Note"><Input value={form.note} onChange={(e) => setForm((f) => ({ ...f, note: e.target.value }))} data-testid="deposit-note" /></Field>
        </div>
        <DialogFooter><Button variant="ghost" onClick={() => onOpenChange(false)}>Annuler</Button><Button onClick={submit} disabled={busy || !(Number(form.amount) > 0)} data-testid="deposit-submit">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Enregistrer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
